import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 px-5 bg-stone-900 text-white" data-id="element-118">
      <div className="flex flex-col items-center text-center" data-id="element-119">
        <ShieldCheck className="w-16 h-16 text-green-400 mb-6" data-id="element-120" />
        <h2 className="text-3xl font-bold mb-4" data-id="element-121">
          Garantía de 7 días sin preguntas
        </h2>

        <p className="text-lg text-stone-300 mb-6 leading-relaxed" data-id="element-122">
          Probá el Ultrapack durante{' '}
          <span className="text-white font-bold" data-id="element-123">7 días completos</span>.
        </p>

        <p className="text-stone-400 mb-6 leading-relaxed" data-id="element-124">
          Si por cualquier motivo sentís que no es lo que esperabas, escribinos
          y te devolvemos el 100% de tu dinero. Sin preguntas. Sin formularios
          complicados. Sin vueltas.
        </p>

        <div className="inline-block bg-stone-800 border border-stone-700 rounded-full px-4 py-2 mt-2" data-id="element-125">
          <p className="text-sm font-medium text-stone-300" data-id="element-126">
            Tasa de devolución{' '}
            <span className="text-green-400 font-bold" data-id="element-127">&lt;1%</span>
          </p>
        </div>
      </div>
    </section>;
}